// TODO move client version info etc. onto this object
module.exports = function() {
    var self = this;
    var extensionFns = [];

    this.addExtension = function(extFn) {
        extensionFns.push(extFn);
    };

    this.init = function() {
        // Return a promise here so that we can wait for it on startup in CudaLaunchApp
        var promises = [];

        extensionFns.forEach(function(extFn) {
            promises.push(extFn.call(self));
        });

        return $.when.apply($, promises);
    };
};


//////////////////
// WEBPACK FOOTER
// ./client_config/ClientConfiguration.js
// module id = 69
// module chunks = 3 4